import { motion } from 'framer-motion';
import { ProductCard } from './ProductCard';
import { CollapsibleGroup, SubHeading } from './CollapsibleGroup';
import { regionSlug } from '../../lib/regions';

const SUBSECTIONS = [
  { id: 'complete', label: 'Complete Guide', keys: ['complete'] },
  { id: 'bundles', label: 'Bundles', keys: ['bundle'] },
  { id: 'volumes', label: 'Individual Volumes & Tools', keys: ['vol1', 'vol2', 'vol3', 'toolkit', 'tools'] },
];
const money = (v) => `A$${Number(v).toFixed(2).replace(/\.00$/, '')}`;

const Grid = ({ items, onBuy }) => (
  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
    {items.map((p, i) => (
      <motion.div key={p.id} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: i * 0.06 }}>
        <ProductCard product={p} onBuy={onBuy} />
      </motion.div>
    ))}
  </div>
);

const CountryGroup = ({ country, items, onBuy, prefix }) => {
  const slug = `${prefix}${regionSlug(country)}`;
  const lowest = Math.min(...items.map((p) => p.price));
  return (
    <CollapsibleGroup id={`country-${slug}`} title={country} image={items.find((p) => p.image_url)?.image_url}
      meta={`${items.length} product${items.length > 1 ? 's' : ''} · from ${money(lowest)}`}>
      {SUBSECTIONS.map((s) => {
        const list = items.filter((p) => s.keys.includes(p.product_key)).sort((a, b) => s.keys.indexOf(a.product_key) - s.keys.indexOf(b.product_key));
        return list.length ? (
          <div key={s.id} data-testid={`country-${slug}-${s.id}`}>
            <SubHeading>{s.label}</SubHeading>
            <Grid items={list} onBuy={onBuy} />
          </div>
        ) : null;
      })}
    </CollapsibleGroup>
  );
};

export const RelocationByCountry = ({ products, onBuy, family = false }) => {
  const byCountry = products.reduce((acc, p) => { const c = p.destination || 'Other'; (acc[c] = acc[c] || []).push(p); return acc; }, {});
  return (
    <div className="bg-white rounded-3xl border border-[#E6DAC5] px-6 md:px-10" data-testid={family ? 'family-relocation-by-country' : 'relocation-by-country'}>
      {Object.keys(byCountry).sort().map((c) => <CountryGroup key={c} country={c} items={byCountry[c]} onBuy={onBuy} prefix={family ? 'family-' : ''} />)}
    </div>
  );
};
